import React from "react";
import {isItalianDevice} from "../../utils/utils";

const AboutMe = () => {
  return (
    <div className="flex flex-col md:flex-row pb-6">
      <div className="w-full md:w-1/2 text-zinc-400 px-6 border-r-[1px] border-r-zinc-800 flex items-center">
        <div className="py-6">
          <h2 className="font-semibold mb-1">Hello! I'm Mauro Cristofoli</h2>
          <p className="text-base leading-6 ">
            {isItalianDevice()
              ? "Nato nel 1995, ho iniziato ad usare un calcolatore a 3 anni e da quel momento non ho mai smesso, questo mi ha portato a conseguire una laurea triennale in tecnologie web e multimediali nel 2019 ed a spendere la maggior parte del mio tempo libero e lavorativo pigiando su una tastiera o progettando le mie idee su una lavagna sempre troppo piccola. Oltre all'informatica, ed a tutti i topic correlati, coltivo numerosi interessi diversi come la grafica vettoriale, la psicologia, la filosofia e la dialettica."
              : "Software and Web developer from Udine, Italy. Born in 1995, I started using computers at the age of 3 and haven't stopped since, which led me to pursue a degree in computer science in 2019 and spend most of my free and working time pressing buttons on a keyboard or designing my ideas on a blackboard that is always too small. In addition to computer science and all topics related to software engineering I cultivate numerous other interests such as vector graphics, psychology, philosophy, and dialectics."}
          </p>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-6">
        <ul className="flex flex-col gap-1">
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">
              {isItalianDevice() ? "Nascita" : "Born"}:
            </span>
            {isItalianDevice() ? "15 Novembre 1995" : "15 November 1995"}
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">
              {isItalianDevice() ? "Residenza" : "Residence"}:
            </span>
            Udine, {isItalianDevice() ? "Italia" : "Italy"}
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">
              {isItalianDevice() ? "Madrelingua" : "First Language"}:
            </span>
            {isItalianDevice() ? "Italiano" : "Italian"}
          </li>
          <li className="aboutRightLi">
            <span className="aboutRightLiSpan">
              {isItalianDevice() ? "Seconda Lingua" : "Second Language"}:
            </span>
            {isItalianDevice() ? "Inglese" : "English"}, B2
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;
